export const TERMS_AND_CONDITIONS_URL = 'https://www.vouchedfor.co.uk/terms-and-conditions'
export const PRIVACY_POLICY_URL = 'https://www.vouchedfor.co.uk/privacy-policy'